import React from 'react';
import classes from '../Styling/SharedStyling.module.css';

export default function BottomLinkBar()
{
  return (
    <div className={classes.bottomBar}>
      <a className={classes.linkElement} title="mailto:support@kylekeirstead.com" href="mailto:support@kylekeirstead.com">
        Contact
      </a>
      <a className={classes.linkElement} target={"_blank"} href="https://www.linkedin.com/in/kyle-keirstead/">
        LinkedIn
      </a>

      <div style={{paddingTop: "10px", fontSize: "14px", cursor: "unset"}} className={classes.linkElementActive}>&#169; {(new Date().getFullYear())} Kyle Keirstead</div>
    </div>
  );
}